export default __webpack_public_path__ + "static/media/Wesley1.41556b75.jpg";